

export function mergeWeeklySchedule(scheduleByDay, maxGapSeconds = 300) {
    const toSeconds = (time) => {
        const [h, m] = time.split(':').map(Number);
        return h * 3600 + m * 60;
    };

    const toTime = (seconds) => {
        const h = String(Math.floor(seconds / 3600)).padStart(2, '0');
        const m = String(Math.floor((seconds % 3600) / 60)).padStart(2, '0');
        return `${h}:${m}`;
    };

    const mergeDayIntervals = (intervals) => {
        if (!intervals || intervals.length === 0) return [];

        const parsed = intervals
            .map(str => {
                const [start, end] = str.split('-').map(toSeconds);
                return { start, end };
            })
            .sort((a, b) => a.start - b.start);

        const merged = [];
        let current = parsed[0];

        for (let i = 1; i < parsed.length; i++) {
            const next = parsed[i];
            const gap = next.start - current.end;

            if (gap <= maxGapSeconds) {
                current.end = Math.max(current.end, next.end);
            } else {
                merged.push({ ...current });
                current = next;
            }
        }
        merged.push(current);

        return merged.map(({ start, end }) => `${toTime(start)}-${toTime(end)}`);
    };

    const mergedSchedule = {};
    for (const day in scheduleByDay) {
        mergedSchedule[day] = mergeDayIntervals(scheduleByDay[day]);
    }

    return mergedSchedule;
}

export function formatWeeklySchedule(schedule) {
    const result = {};

    for (const day in schedule) {
        const daySchedule = schedule[day];

        if (!daySchedule || !daySchedule.length) {
            result[day] = [];
            continue;
        }

        const scheduleLines = daySchedule
            .map(function ([from, to]) {
                return [new Date(from), new Date(to)];
            })
            .sort(function (a, b) {
                return a[0].getTime() - b[0].getTime();
            });

        const merged = [];
        let currentStart = scheduleLines[0][0];
        let currentEnd = scheduleLines[0][1];

        for (let i = 1; i < scheduleLines.length; i++) {
            const nextStart = scheduleLines[i][0];
            const nextEnd = scheduleLines[i][1];
            const gap = (nextStart.getTime() - currentEnd.getTime()) / 1000;

            if (gap >= 0 && gap <= 3) {
                currentEnd = nextEnd > currentEnd ? nextEnd : currentEnd;
            } else {
                merged.push([currentStart, currentEnd]);
                currentStart = nextStart;
                currentEnd = nextEnd;
            }
        }
        merged.push([currentStart, currentEnd]);

        const first = merged[0][0];
        const last = merged[merged.length - 1][1];

        const dayStart = new Date(first);
        dayStart.setHours(0, 0, 0, 0);

        const dayEnd = new Date(first);
        dayEnd.setHours(23, 59, 0, 0);

        const startGap = (first.getTime() - dayStart.getTime()) / 1000;
        const endGap = (dayEnd.getTime() - last.getTime()) / 1000;

        if (merged.length === 1 && startGap <= 60 && endGap <= 60) {
            result[day] = ["00:00-24:00"];
            continue;
        }

        result[day] = merged.map(function ([from, to]) {
            const hhFrom = String(from.getHours()).padStart(2, "0");
            const mmFrom = String(from.getMinutes()).padStart(2, "0");
            const hhTo = String(to.getHours()).padStart(2, "0");
            const mmTo = String(to.getMinutes()).padStart(2, "0");

            if (hhTo === "23" && mmTo === "59") {
                return hhFrom + ":" + mmFrom + "-24:00";
            } else {
                return hhFrom + ":" + mmFrom + "-" + hhTo + ":" + mmTo;
            }
        });
    }

    return result;
}